import { RcFile } from 'antd/lib/upload';
import GraphqlService from '../services/graphql/GraphqlService';
import {
  DocumentTypeEnum,
  EnumsValues,
  ExportReceiptHeadersMapKeys,
} from '../enums/EnumsValues';

const useDocumentService = () => {
  const { Mutation, customFileRequest, customRequest, Query } =
    GraphqlService();

  const getDocuments = async ({
    tenant_id,
    document_type,
    skip,
    take,
    searchText,
  }: {
    tenant_id: number;
    document_type?: DocumentTypeEnum;
    skip?: number;
    take?: number;
    searchText?: string;
  }) => {
    return customRequest({
      query: Query.getDocuments,
      variables: {
        input: {
          tenant_id: tenant_id,
          document_type: document_type,
          skip: skip,
          take: take,
          searchText: searchText,
        },
      },
    });
  };

  const getDocumentsCount = async ({
    tenant_id,
    document_type,
  }: {
    tenant_id: number;
    document_type?: DocumentTypeEnum;
  }) => {
    return customRequest({
      query: Query.getDocumentsCount,
      variables: {
        input: {
          tenant_id: tenant_id,
          document_type: document_type,
        },
      },
    });
  };

  const createPendingDocument = async (
    tenant_id: number,
    file: RcFile,
    validateDuplicated: boolean = true,
    documentType?: DocumentTypeEnum,
  ) => {
    return customFileRequest(
      {
        maxRetriesNumber: EnumsValues.CustomValues.MaxRetriesUploadingReceipts,
        mutation: Mutation.createPendingDocument,
        variables: {
          file: {
            filename: file.name,
            mimetype: file.type,
            encoding: 'base64',
          },
          input: {
            tenant_id: tenant_id,
            validate_duplicity: validateDuplicated,
            document_type: documentType,
          },
        },
      },
      [{ file: file, path: 'variables.file' }],
    );
  };

  const getDocumentPdf = async (documentId: number) => {
    return customRequest({
      query: Query.getDocumentPdfFile,
      variables: {
        document_id: documentId,
      },
    });
  };

  const exportDocuments = async ({
    format,
    tenantId,
    documentType,
    exportMapKey,
    filters,
  }: {
    format: string;
    tenantId: number;
    documentType?: DocumentTypeEnum;
    exportMapKey?: ExportReceiptHeadersMapKeys;
    filters?: number[];
  }) => {
    return customRequest({
      query: Query.exportDocuments,
      variables: {
        input: {
          tenant_id: tenantId,
          format: format,
          columnsPerPages: {
            columnsPerPage: [],
          },
          exportMapKey:
            exportMapKey ||
            EnumsValues.ExportReceiptHeadersMapKeys.DynamicDocument,
          document_type: documentType,
          filters: filters,
        },
      },
    });
  };

  return {
    createPendingDocument,
    getDocuments,
    getDocumentsCount,
    getDocumentPdf,
    exportDocuments,
  };
};

export default useDocumentService;
